module.exports = __webpack_public_path__ + "img/subline2_de.e8ccc849.png";